import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";
import { createOpenApiConfiguration } from "@/lib/utils";
import { SeasonsApi } from "@/openapi/generated";

export const useSeasonsGet = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: [QueryKeys.Seasons],
    queryFn: () => {
      // Create API instance without authentication for public access
      const service = new SeasonsApi(createOpenApiConfiguration());
      return service.apiSeasonsScrollGet({
        page: 1,
        pageSize: 1000,
      });
    },
    enabled,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    isFetching,
    refetch,
  };
};
